import { persistAuth } from "../../../api/auth";

async function initFirebase() {
  await persistAuth();
}

async function main() {
  await initFirebase();
  return;
}

export default main;
